
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import { defineComponent } from "vue";
import { getConveniText } from "common/src/utils/codes";
import constants from "common/src/constants";

export default defineComponent({
  setup() {
    const store = useStore();

    if (store.state.renewal === undefined) {
      router.push({ name: "Renewal" });
    } else if (store.state.renewal.rnw01p.tfReconv === "") {
      router.push({ name: "Payment" });
    }

    // コンビニ払いの場合のみ表示する情報を取得
    // 直接入金などが増える可能性があるので、表示制御を一応入れている
    const isConveni = store.state.conveni !== undefined;
    const conveniCode = store.state.conveni?.tfReconv;
    const conveniConf = store.state.conveni?.tfRecono;
    const conveniRecipt = store.state.conveni?.tfRereno;
    const conveniPayTerm = store.state.conveni?.tfRepydt;
    const conveniReciptUrl = store.state.conveni?.receiptUrl;

    // ストアの更新データ・コンビニデータをリセット
    store.commit(MutationTypes.RESET_RENEWAL);

    return {
      isConveni,
      conveniCode,
      conveniConf,
      conveniRecipt,
      conveniPayTerm,
      conveniReciptUrl,
      constants,
      getConveniText,
    };
  },
});
